import axios from 'ps-components/lib/apiClient';
import { useMutation } from 'react-query';
import { useAppState } from '../redux';
import addAlert from 'ps-components/AlertToast/addAlert';

type CloneReportPayload = {
    report_pk: number
    category_pk: number
    new_report_name: string
    new_report_scope_code: string
}

export const useCloneReport = () => {
    const appState = useAppState()
    const { csrf_timestamp, csrf_token } = appState.session
    const cloneReport = async (payload: CloneReportPayload) => {
        const response = await axios.apiPost('/api/report-writer/report/clone', { ...payload, clone_report: true, csrf_timestamp, csrf_token })
        if (!response.data.success) throw new Error(response.data.save_message || 'Error cloning report')
        return response.data
    }

    const mutation = useMutation(cloneReport, {
        onSuccess: () => addAlert('Success. You are now viewing the cloned report', 'success')
    })
    return mutation
}